// AnimatedText.js
import React from "react";
import '../styles/Textanimation.css';
import { useInView } from "react-intersection-observer";

// import styles from "../../styles/AnimatedText.module.css";
const AnimatedText5 = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, // animate only once when it first comes into view
    threshold: 0.1,    // trigger when 10% of the component is in view
  });
  return (
    <div ref={ref} className={`container ${inView ? "animate" : ""}`}>
      <div className="text a"> How </div>
      <div className="text b"> we </div>
      <div className="text c"> deliver  </div>
    </div>
  );
};
export default AnimatedText5;